import React from "react";
import {useSelector} from "react-redux";
import {Checkbox, FormControlLabel} from "@material-ui/core";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";

const CheckboxComponent = (props) => {
    const {component} = props;
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(component.properties.label, userLanguage)
    return (
        <FormControlLabel
            labelPlacement={component.styles.labelPlacement}
            control={
                <Checkbox
                    defaultChecked
                    disabled
                    size={component.styles.size}
                />}
            label={multiLanguageLabel}
        />

    )
}
export default CheckboxComponent